const apiUrl = process.env.REACT_APP_API_URL;

export const GetProjecteImagen = async (id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id}/imagen`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            return await response.json();
        }
    } catch (error) {
        console.log('Error al obtener la imagen:', error);
    }
    return null;
};
